import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "exam-time"
};
const _hoisted_2 = {
  key: 1,
  class: "paper-context"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_mcq = _resolveComponent("mcq");
  const _component_saq = _resolveComponent("saq");
  const _component_pwco = _resolveComponent("pwco");
  const _component_proofreading = _resolveComponent("proofreading");
  const _component_MenuBox = _resolveComponent("MenuBox");
  return _openBlock(), _createElementBlock(_Fragment, null, [$setup.paperInfo.items ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "margin-right": "5px",
      "font-size": "20px"
    },
    icon: $setup.Timer,
    size: "large"
  }, null, 8, ["icon"]), _createElementVNode("p", null, [_cache[2] || (_cache[2] = _createTextVNode(" 考试时间", -1)), _createElementVNode("span", null, _toDisplayString($setup.timeText), 1)]), _withDirectives(_createVNode(_component_el_button, {
    color: "#1d5595",
    type: "success",
    size: "large",
    onClick: _cache[0] || (_cache[0] = $event => $setup.finishExam(1))
  }, {
    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("交 卷", -1)]))]),
    _: 1
  }, 512), [[_vShow, $props.examInfo.subdivide == 3]])])) : _createCommentVNode("", true), $setup.paperInfo.items ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' ? (_openBlock(), _createBlock(_component_mcq, {
    key: 0,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers
  }, null, 8, ["questionInfo", "onSetAnswer", "allAnswers"])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'saq' ? (_openBlock(), _createBlock(_component_saq, {
    key: 1,
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers,
    questionInfo: $setup.paperInfo.items[$setup.itemNo]
  }, null, 8, ["onSetAnswer", "allAnswers", "questionInfo"])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'pwco' ? (_openBlock(), _createBlock(_component_pwco, {
    key: 2,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'proofreading' ? (_openBlock(), _createBlock(_component_proofreading, {
    key: 3,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.paperInfo.items ? (_openBlock(), _createBlock(_component_MenuBox, {
    key: 2,
    examType: $props.examInfo.subdivide,
    paperInfo: $setup.paperInfo,
    itemNo: $setup.itemNo,
    answers: $setup.cache.answers,
    onChangeItem: _cache[1] || (_cache[1] = no => {
      $setup.itemNo = no;
      $setup.setcache();
    })
  }, null, 8, ["examType", "paperInfo", "itemNo", "answers"])) : _createCommentVNode("", true)], 64);
}